














	// @ts-ignore
    import _ from './MPopupWebPrivate.ts'; export default _;
